import axios from 'axios';

import useCookie from './useCookie';

import { toast } from 'react-toastify';

function useRequest() {
    const { getCookie } = useCookie();

    async function request(path, data = {}, headerData = {}) {
        var options = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-CSRF-Token': getCookie("CSRF-Token"),
            }
        };

        options.headers = {...options.headers, ...headerData }

        try {
            const result = await axios.post(path, data, options);
            return result;
        }
        catch (ex) {
            switch (ex.response.status) {
                case 400:
                    toast.error("Error 400: Bad Request");
                    return;
                    break;
                case 401:
                    toast.error("Error 401: Unauthorized");
                    return;
                    break;
                case 404:
                    toast.error("Error 404: Page not found");
                    return;
                    break;
                default:
                    toast.error("Unknown Error");
                    break;
            }
            console.error(ex);
            throw ex;
        }
    }

    return { request };
}

export default useRequest;